import { EStoreType } from '@gelato-api-ui/core/e-commerce/e-store-type.enum';

export const storeLimits = {
  [EStoreType.SHOPIFY]: 100,
  [EStoreType.ETSY]: 400,
};
export const STORES_WITH_VARIANTS_LIMITS = [EStoreType.SHOPIFY, EStoreType.ETSY];
